import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { useHeavyUpdateInterval } from 'lib/hooks/useHeavyUpdateInterval';
import { useData } from './useData';

const RefreshContext = createContext({
  refetch: () => {},
  resyncForCategorize: () => {
    return Promise.resolve();
  },
});

const DataProvider = ({ children }) => {
  useHeavyUpdateInterval();
  const { refetch, resyncForCategorize } = useData();

  return (
    <RefreshContext.Provider value={{ refetch, resyncForCategorize }}>
      {children}
    </RefreshContext.Provider>
  );
};

DataProvider.propTypes = {
  children: PropTypes.any,
};

export { DataProvider, RefreshContext };
